import {
  GET_RRHH_REQUEST,
  GET_RRHH_SUCCESS,
  RESET_RRHH,
} from '../../actions/constants/rrhh/rrhh.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 25,
  sede: null,
  tipoListado: 'listar',
  rrhhSeleccionados: [],
};

export default function rrhhReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_RRHH_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_RRHH_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      const { listado } = state;
      return {
        ...state, listado: [...listado, ...datos], total, loading: false, page, start, limit,
      };
    }

    case RESET_RRHH: {
      return {
        ...state, page: 1, start: 0, total: 25, listado: [],
      };
    }

    default:
      return state;
  }
}
